import { useTranslation } from 'next-i18next'
import React from 'react'

import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

import { ToolTipWrapper, TOP_TIP_POSITION } from '../tooltip'

import InfoIcon from './infoIcon.inline.svg'
import styles from './productTraditionalDiscountMessage.module.scss'

export interface ProductTraditionalDiscountMessageProps {
  formattedTraditionalPrice?: string
  traditionalDiscountMessage?: string
}

const ProductTraditionalDiscountMessage = ({
  formattedTraditionalPrice,
  traditionalDiscountMessage,
}: ProductTraditionalDiscountMessageProps) => {
  const { deviceType } = useDeviceInfo()
  const isDesktop = deviceType === DEVICE_TYPES.DESKTOP
  const { t } = useTranslation('common')
  return (
    <>
      {!formattedTraditionalPrice && traditionalDiscountMessage && (
        <div className={styles.traditionalDiscountTextWrapper}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(traditionalDiscountMessage),
            }}
          ></div>
          <ToolTipWrapper
            topTipPosition={isDesktop ? TOP_TIP_POSITION.TOP : TOP_TIP_POSITION.BOTTOM}
            className={styles.infoIcon}
            toolTipContentRenderer={() => t('traditional_discount_tooltip')}
            toolTipContentClassName={styles.toolTipContentWrapper}
          >
            <InfoIcon />
          </ToolTipWrapper>
        </div>
      )}
    </>
  )
}

export default ProductTraditionalDiscountMessage
